import { Bookmark, Clapperboard, Crown, Flame, Gem, Hash, Heart, LocateFixed, Medal, Rocket, Shuffle, Sparkles, Trophy, TvMinimalPlay, UserPlus, Users } from "lucide-react";
import type { UiMessages } from "@/lib/locales/types";

export interface NavItem {
  href: string;
  label: string;
  /** Its name in the interface's words (lib/locales), which replaces `label` in the page's language. */
  key?: keyof UiMessages["nav"];
  icon: React.ComponentType<{ size?: number; strokeWidth?: number; className?: string }>;
  external?: boolean;
  /** An external link of our own (the Telegram channel), not a partner's. */
  own?: boolean;
  /** Counted when clicked (data-stat, lib/stats.ts). */
  stat?: string;
  /** Goes to a random video (components/video/RandomVideo.tsx) rather than to a page. */
  random?: boolean;
  /** A dot on the item: "coins" while today's Sweet Coins are waiting. */
  badge?: "coins";
}

// The menu's Streams / Videos switch (Sidebar.tsx) leads to the home page (live streams) and /videos.
export const MAIN_NAV: NavItem[] = [
  { href: "/for-you", label: "For you", key: "forYou", icon: Sparkles },
  { href: "/hot", label: "Hot now", key: "hot", icon: Flame },
  { href: "/random", label: "Random video", key: "random", icon: Shuffle, random: true },
  { href: "/following", label: "Following", key: "following", icon: LocateFixed },
  { href: "/watching", label: "Watching", key: "watching", icon: TvMinimalPlay },
  { href: "/rankings", label: "Rankings", key: "rankings", icon: Trophy },
  { href: "/invite", label: "Invite friends", key: "invite", icon: UserPlus },
  { href: "/achievements", label: "Achievements", key: "achievements", icon: Medal },
  { href: "/saved", label: "Saved", key: "saved", icon: Bookmark },
  { href: "/reacted", label: "Reacted", key: "reacted", icon: Heart },
  { href: "/boost", label: "Sweet Boost", key: "boost", icon: Rocket },
  { href: "/subscription", label: "Premium", key: "premium", icon: Crown, badge: "coins" },
];

export const BROWSE_NAV: NavItem[] = [
  { href: "/people", label: "Pornstars", key: "stars", icon: Users },
  { href: "/brands", label: "Studios", key: "productions", icon: Clapperboard },
  { href: "/premium-porn-sites", label: "Premium sites", key: "paysites", icon: Gem },
  { href: "/categories", label: "Categories", key: "categories", icon: Hash },
];

/** The item with its label in the page's language. */
export const translated = (item: NavItem, t: UiMessages): NavItem => (item.key ? { ...item, label: t.nav[item.key] } : item);

export function isActive(pathname: string | null, href: string) {
  if (!pathname) return false;
  return href === "/" ? pathname === "/" : pathname === href || pathname.startsWith(`${href}/`);
}
